import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'

import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import awsconfig from './aws-exports'

import axios from 'axios'
import VueAxios from 'vue-axios'

import store from './store.js'

//import VueAnalytics from 'vue-analytics'

import VueGtag from "vue-gtag";
import MarkGtagMixin from './mixins/gtag'

import  { Logger} from 'aws-amplify';
const logger = new Logger('main','INFO');

logger.info("hostname",location.hostname)

/*
Vue.use(VueAnalytics,{
  id:'UA-151000855-1',
  linkers: [location.hostname, 'localhost','shop.airdt.app']
})
 */
Vue.use(VueGtag, {
  config: { id: "UA-151000855-1",
    /*
    We do this at app.js instead
    params:{
      linker:{
        domains:[location.hostname, 'localhost','shop.airdt.app']
      }
    },

     */

  },
  includes:[
    {id:"AW-736955098"},
  ]
});


Vue.mixin(MarkGtagMixin)

logger.info("hostname",location.hostname)

Vue.config.productionTip = false

Amplify.configure(awsconfig)
Vue.use(AmplifyPlugin, AmplifyModules)
Vue.use(VueAxios, axios)

new Vue({
  router,
  store,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app')
